export const buildCharacterFrames = (text) => {
  const occurrences = new Map();

  return Array.from(text).map((char) => {
    const token = char === " " ? "space" : char.toLowerCase();
    const nextCount = (occurrences.get(token) ?? 0) + 1;
    occurrences.set(token, nextCount);

    return {
      id: `${token}-${nextCount}`,
      char,
    };
  });
};